import { useEffect, useState } from "react"
import {Link, useNavigate} from "react-router-dom"
import { getCategories } from "@/api/categoryApi"

export default function CategorySection() {
    const navigate = useNavigate()
    const [mainCategories, setMainCategories] = useState<any[]>([])

    useEffect(() => {
        const fetchMainCategories = async () => {
            try {
                // 주요(isMain='Y') 카테고리만 가져옵니다.
                const response = await getCategories(true)
                const categoryList = response?.data?.items || response?.items || response?.data || []
                setMainCategories(Array.isArray(categoryList) ? categoryList : [])
            } catch (error) {
                console.error("주요 카테고리 로딩 실패:", error)
                setMainCategories([])
            }
        }
        fetchMainCategories()
    }, [])

    return (
        <section className="mx-auto max-w-7xl px-4 py-6 lg:px-6">
            <div className="mb-5 flex items-end justify-between">
                <div>
                    <h2 className="text-2xl font-bold">주요 카테고리</h2>
                    <p className="mt-1 text-sm text-slate-500">
                        메인에서 바로 진입할 수 있는 대표 카테고리
                    </p>
                </div>
                {/*<button*/}
                {/*    onClick={() => navigate('/categories')}*/}
                {/*    className="text-sm font-medium text-slate-700 hover:text-slate-900"*/}
                {/*>*/}
                {/*    전체 보기*/}
                {/*</button>*/}

                <Link
                  to="/categories"
                  className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
                >
                    전체 보기 &gt;
                </Link>
            </div>

            <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                {mainCategories.map((category) => (
                    <div
                        key={category.categoryId}
                        className="rounded-[24px] border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-md cursor-pointer flex flex-col items-center text-center"
                        onClick={() => navigate(`/products?categoryId=${category.categoryId}`)}
                    >
                        {/* 💡 핵심 수정 부분: 텍스트 대신 img 태그로 렌더링! */}
                        <div className="mb-4 h-16 w-16 overflow-hidden rounded-2xl flex items-center justify-center">
                            {category.icon && category.icon.startsWith('http') ? (
                                <img src={category.icon} alt={category.name} className="h-full w-full object-cover" />
                            ) : (
                                <div className="text-4xl">{category.icon || "📁"}</div> // 예외 처리 (이모지나 빈 값)
                            )}
                        </div>

                        <h3 className="text-lg font-bold">{category.name}</h3>
                        {/*<p className="mt-2 text-sm text-slate-500">{category.description}</p>*/}

                        <button className="mt-auto w-full mt-5 rounded-xl bg-slate-50 px-4 py-2 text-sm font-medium text-slate-800 hover:bg-slate-200 transition-colors">
                            바로가기
                        </button>
                    </div>
                ))}
            </div>
        </section>
    )
}